<template>
  <div style="width:100vw">
    <gmap-map 
      :center="center" 
      :zoom="int_zoom" 
      style="width:100%; height:100vh;" 
      :options="options"
      class="map_marker">
        <gmap-marker 
          :key="index" 
          v-for="(m, index) in markers" 
          :position="m.position" 
          :draggable="false" 
        >
        </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "TrackDriverMap",
  props: {
    location: {
      type: Object,
      default:() =>{
        return {
          customer: {
            position: { lat: 0, lng: 0 },
            addr: 0,
            icon: 0
          }
        }
      }
    }
  },
  data() {
    return {
      int_zoom: 16,
      center: { lat: 3.168469, lng: 101.6511722 },
      markers: [],
      places: [],
      currentPlace: null,
      value: {},
      options: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    };
  },
  created() {
      this.markers.push({ position: this.location.customer.position})
      this.center = this.location.customer.position
  },
  methods: {

  }
};
</script>